export default {"src":"/_next/static/image/public/images/ic_home_package.e0b2b21f1186066dbf3a7da62c3b1545.svg","height":15,"width":14};